import {
  VuexModule, Module, Mutation, Action,
} from 'vuex-module-decorators';
import ProjectWithMembers from '@/domain/project/project-with-members.entity';
import store from '@/store';
import ProjectSearchservice from '@/domain/project/project-search.service';


@Module({ dynamic: true, name: 'projectWithMembersStore', store })
export default class projectWithMembersStore extends VuexModule {
  private projectUserList: ProjectWithMembers[] = [];

  private projectsService = new ProjectSearchservice();

  @Mutation
  updateProjects(projects: ProjectWithMembers[]) {
    this.projectUserList = projects;
  }

  @Action
  async fetchProjects() {
    const fetched = await ProjectSearchservice.getAllProjectsByUser();
    this.updateProjects(fetched);
  }

  get getAllProjectsUser() : ProjectWithMembers[] {
    return this.projectUserList;
  }

  @Action
  async getProject(name: string) {
    const project = this.projectUserList.find(projectUser => projectUser.name === name);
    if (project) {
      return project;
    }
    throw new Error('Project not found.');
  }
}
